export const PROCESS_LIVE_EVENT = 'liveEvents/process'
export const TRIM_LIVE_EVENTS = 'liveEvents/trim'


export const processLiveEvent = (event) => ({
    type: PROCESS_LIVE_EVENT,
    event
})
